<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <!-- لایه انتظار برای ذخیره خودکار -->
    <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
      <div class="text-center d-flex flex-column align-center justify-center">
        <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118" />
        <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
        <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
      </div>
    </v-overlay>

    <!-- پیش‌نمایش در پنجره Gateway -->
    <template v-if="showGatewayPopup">
      <v-row class="pa-2" no-gutters>
        <v-col cols="12">
          <qr-edit-gateway
            v-model="showGatewayPopup"
            :sections="gatewaySections"
            :form-data="data"
            @edit-all="handleEditAll"
            @save="qrUpdate(false)"
            @cancel="onCancel"
          >
            <template v-slot:preview style="position: relative; min-height: 100%;">
              <v-card
                v-if="resLoading || loading"
                class="d-flex align-center justify-center mt-10"
                flat
                min-height="50vh"
              >
                <v-progress-circular indeterminate size="50" width="5" color="grey" />
              </v-card>
              <div v-else class="sticky-preview">
                <component
                  :is="theme"
                  :order.sync="data.order"
                  v-model="data"
                  :components="specialInfo"
                  :qr-svg-data-url="qrSvgDataUrl"

                />
              </div>
            </template>
          </qr-edit-gateway>
        </v-col>
      </v-row>
    </template>

    <!-- فرم اصلی ویرایش و پیش‌نمایش زنده در کنار آن -->
    <template v-else>
      <v-row class="pa-2" no-gutters>
        <!-- ستون پیش‌نمایش گوشی -->
        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 110px; height: fit-content"
        >
          <v-card
            v-if="resLoading"
            class="d-flex align-center justify-center"
            flat
            min-height="50vh"
          >
            <v-progress-circular
              class="mx-auto"
              indeterminate
              size="50"
              width="5"
              color="primary"
            />
          </v-card>
          <component
            :is="theme"
            :order.sync="data.order"
            v-else
            v-model="data"
            :components="specialInfo"
            :qr-svg-data-url="qrSvgDataUrl"

          />
        </v-col>

        <!-- ستون فیلدها و استپر تنظیمات -->
        <v-col class="pa-2 px-0" cols="12" md="8">
          <v-card :disabled="loading" flat>
            <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
              <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
                <div class="row justify-center">
                  <div class="col-md-12">
                    <p class="font-weight-bold text-subtitle-1">ویرایش اطلاعات لیبل قیمت</p>
                  </div>
                  
                  <!-- فیلد عنوان محصول -->
                  <div class="col-md-6 mt-0 pt-0">
                    <div class="rowinfo">
                      <v-text-field
                        v-model="data.visitName"
                        append-icon="mdi-pen"
                        class="mt-0 pt-0 contentinfo"
                        clear-icon="mdi-close-circle-outline"
                        clearable
                        dense
                        label="نام محصول شما"
                        outlined
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-data-visitName`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        label="نام محصول"
                      />
                    </div>
                  </div>

                  <!-- شناسه و آدرس کیوآر (فقط خواندنی) -->
                  <div class="col-md-6 mt-0 pt-0">
                    <div class="rowinfo">
                      <qr-address-field
                        id="qr-address"
                        v-model="res.identifier"
                        :domain-id="res.domain_id"
                        :error-messages="errors['identifier']"
                        append-icon="mdi-web"
                        class="mt-0 pt-0 contentinfo"
                        dense
                        :key="$t('qrAddressUpdate.hints.allowedChars')"
                        :hint="$t('qrAddressUpdate.hints.allowedChars')"
                        outlined
                        persistent-hint
                        readonly
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-res-identifier`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        label="شناسه اختصاصی"
                      />
                    </div>
                  </div>
                </div>
              </v-stepper-step>

              <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
                <div class="mb-4 mx-4">
                  <!-- سوییچ ذخیره خودکار -->
                  <div class="d-flex align-center">
                    <v-switch
                      v-model="AutoSave"
                      color="primary"
                      class="mt-0 pt-0 shrink"
                      hide-details
                      label="ذخیره خودکار"
                    ></v-switch>

                    <!-- راهنمای تولتیپ -->
                    <v-tooltip bottom max-width="320">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          x-small
                          class="mr-1"
                          v-bind="attrs"
                          v-on="on"
                          @click.stop
                        >
                          <v-icon small color="grey darken-1">
                            mdi-help-circle-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>
                        تغییرات هر بخش با بستن آکاردئون به‌صورت خودکار در سرور ذخیره می‌شود.
                      </span>
                    </v-tooltip>
                  </div>

                  <div
                    v-if="$vuetify.breakpoint.xsOnly"
                    class="text-caption grey--text text--darken-1 mt-1 pr-1"
                    style="line-height: 1.4"
                  >
                    تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود.
                  </div>
                </div>

                <!-- لیست آکاردئون‌های تنظیمات (قیمت، تصویر، پالت رنگ) -->
                <list-expansion
                  v-model="data"
                  :components="specialInfo"
                  :order.sync="data.order"
                  :data="data"
                  flat
                  @save-required="AutoSave && qrUpdate(false)"
                />

                <!-- دکمه نهایی ثبت تغییرات -->
                <div class="col-md-12 mt-4">
                  <next-btn
                    :loading="loading"
                    title="ذخیره و پایان ویرایش"
                    style="background: #1b8d39"
                    @click="qrUpdate(true)"
                  />
                </div>
              </v-stepper-content>
            </v-stepper>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import HelpInfo from "../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import QrGenerator from "../qrland/components/qrGenerator";
import QrMaker from "../qrland/components/qrMaker";
import { Bus } from "@/main";
import QrCustomize from "../qrland/components/qrCustomize.vue";
import DownloadFile from "../qrland/downloadFile";
import ListExpansion from "../../content/fragments/listExpansion";
import NextBtn from "../../content/fragments/nextBtn";
import PrevBtn from "../../content/fragments/prevBtn";
import QrAddressField from "../../content/fragments/qrAddressField";
import NewProCard from "@/view/components/Product/newProCard";
import ProductTheme2 from "@/view/pages/product/productTheme2";
import ThemeSelector2 from "@/view/pages/product/themeSelector";
import NewDesign from "@/view/pages/product/newDesign";
import QrCodeMake from "@/view/pages/qrland/qrCodeStyle/qrCodeMake.vue";
import ImageToTextInfAi from "@/view/components/adapters/AIGeneration/imageToTextInfAi.vue";
import armsChooser from "@/view/components/Product/armsChooser.vue";
import { mapActions } from "vuex";
import QrEditGateway from "../qrland/components/QrEditGateway.vue";
import { AtomSpinner } from "epic-spinners";
import PriceLabelTheme from "./components/priceLabelTheme.vue";

export default {
  name: "editPriceLabel",

  components: {
    ImageToTextInfAi,
    HelpInfo,
    HelpInfoWrapper,
    QrCodeMake,
    NewDesign,
    ThemeSelector2,
    ProductTheme2,
    NewProCard,
    QrAddressField,
    PrevBtn,
    NextBtn,
    ListExpansion,
    DownloadFile,
    QrCustomize,
    QrMaker,
    QrGenerator,
    armsChooser,
    QrEditGateway,
    AtomSpinner,
    PriceLabelTheme,
  },

  data() {
    return {
      showGatewayPopup: this.$route?.query?.gateway === "true",
      isAutoSaving: false,
      AutoSave: false,
      helpData: [],
      serviceName: "Qrland",
      componentName: "price-label-card",
      theme: "PriceLabelTheme",
      qrDesign: {},
      cons: { title: "ویرایش کیوآر لیبل قیمت" },
      e6: 1,
      errors: {},
      createdId: null,
      loading: false,
      resLoading: false,
      showDialog: false,

      // لیست بخش‌های تنظیمات
      specialInfo: [
        {
          name: "priceLabelInfo",
          value: "",
          title: "اطلاعات قیمت محصول",
          icon: "currency-usd",
          model: "label",
        },
        {
          name: "imageUploader",
          value: "",
          title: "افزودن تصویر",
          subtitle: "تصویر لوگو یا عکس محصول",
          icon: "cloud-upload-outline",
          model: "photo",
        },
        {
          name: "colorPallete",
          value: "",
          title: "انتخاب رنگ",
          icon: "format-color-fill",
          model: "pallete",
          secondName: "",
        },
      ],

      dtUrl: null,
      domainId: null,
      res: {},
      
      data: {
        order: [
          { name: "brand" },
          { name: "price" },
          { name: "bPrice" },
          { name: "cPrice" },
          { name: "discount" },
          { name: "discriptions" },
        ],
        pallete: {
          headColor: "linear-gradient(to top left , #00BCD4FF, #2F0743FF)",
          bodyColor: "linear-gradient(to top left , #006064FF, #03A9F4FF)",
          textColor: "#000",
          borderColor: "#393939",
        },
        photo: {
          background: "https://cdn.terminalads.com/upload/64b2bb1c4ad38.webp",
          src: "",
        },
        label: {
          name: { text: "نام مجموعه", line: false },
          labelName: { text: "نام محصول", line: false },
          price: { text: 1000, line: false },
          bPrice: { text: 1200, line: false },
          cPrice: { text: 1100, line: false },
          discount: { text: 5, line: false },
          discriptions: { text: "درباره محصول و ویژگی‌های اصلی...", line: false },
          brand: { text: "", line: false },
        },
        visitName: "لیبل قیمت",
      },
      qrSvgDataUrl: "",
      info: null,
    };
  },

  provide: {
    provideSingleGallery: true,
  },

  mounted() {
    this.fetchData();
  },

  computed: {
    domainName() {
      return this.$route.params?.name?.replace("?gateway=true", "") || "";
    },
    qrId() {
      return this.$route.params?.id?.replace("?gateway=true", "") || "";
    },
    gatewaySections() {
      return this.specialInfo.map((item) => {
        return { ...item, description: item.title };
      });
    },
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID", "setQrType"]),
    ...mapActions("local", [
      "updateQrId",
      "updateQridentifier",
      "updateQrInfo",
      "updateQrDomain",
    ]),

    handleEditAll() {
      this.showGatewayPopup = false;
    },

    onCancel() {
      this.$router.push({ name: "qr.list" });
    },

    fetchData() {
      const fixData = (data) => {
        let fixed = { ...data.data };

        if (
          !fixed.label?.more ||
          (typeof fixed.label.more === "object" && !Array.isArray(fixed.label.more))
        ) {
          fixed.gold = {
            ...fixed.label,
            more: [],
          };
        }

        // نرمال‌سازی فیلد تصویر
        if (!fixed.photo) {
          fixed.photo = {
            background: (this.$cdnUrl || "https://cdn.terminalads.com") + "/upload/64b2bb1c4ad38.webp",
            src: "",
          };
        } else if (typeof fixed.photo === "string") {
          fixed.photo = {
            background: fixed.photo,
            src: fixed.photo,
          };
        } else if (typeof fixed.photo === "object" && !fixed.photo.background) {
          fixed.photo.background = fixed.photo.src || (this.$cdnUrl || "https://cdn.terminalads.com") + "/upload/64b2bb1c4ad38.webp";
        }

        if (!fixed.companyNumberName) fixed.companyNumberName = "";

        return {
          ...data,
          data: fixed,
        };
      };

      this.loading = true;
      this.resLoading = true;

      this.$api
        .get(
          `/v1/testQr/find/${this.domainName}${
            !!this.qrId ? "/" + this.qrId : ""
          }`
        )
        .then(({ data }) => {
          this.setCreatedQrID(data.data.id);
          this.qrSvgDataUrl= data?.data?.img_url||''; 

          let info = fixData(data.data.data);
          this.data = info.data;
          this.updateQrInfo(info);
          this.updateQrId(data.data.id);
          this.updateQrDomain();
          this.updateQridentifier(data.data.identifier);
          this.setQrType(data.data.type);

          this.theme =
            info.theme && info.theme.length > 0
              ? info.theme
              : "PriceLabelTheme";
          this.res = data.data;
        })
        .catch((err) => {
          console.error("Error loading label data:", err);
          this.$toast.error("خطا در دریافت اطلاعات لیبل قیمت");
        })
        .finally(() => {
          this.loading = false;
          this.resLoading = false;
        });
    },

    isValidValue(value, key) {
      if (value == 0) return false;
      if (value == null || value === "") return false;
      if (typeof value === "string") return value.trim().length > 0;
      if (typeof value === "number") return true;
      if (Array.isArray(value)) return value.length > 0;
      if (typeof value === "object" && value.text != null)
        return value.text.toString().trim().length > 0;
      if (typeof value == "boolean") return value;
      if (typeof value === "object" && value.text == null) return false;

      return !!value;
    },

    qrUpdate(final = false) {
      if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }

      const params = new URLSearchParams();
      params.append("type", "pricelabel");
      params.append("qrType", "dynamic");
      params.append("title", this.res.title || this.data.visitName);
      params.append("domain", this.res.domain?.name || "");
      params.append("identifier", this.res.identifier || "");
      params.append("qr_id", this.res.qrId || this.res.id);

      params.append(
        "data",
        JSON.stringify({
          theme: this.theme,
          data: this.data,
        })
      );

      this.$api
        .put("/v1/testQr/update", params, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then(({ data }) => {
          if (final || !this.AutoSave) {
            this.$toast.success("کیوآر لیبل محصول شما با موفقیت ویرایش شد.");
          }

          if (final) {
            this.$router.push({ name: "qr.list" });
          }
        })
        .catch(({ response }) => {
          console.error("error in updating qr:", response);
          this.$toast.error("خطا در ذخیره‌سازی اطلاعات");
        })
        .finally(() => {
          this.loading = false;
          this.isAutoSaving = false;
        });
    },
  },
};
</script>

<style scoped>
.sticky-preview {
  position: -webkit-sticky;
  position: sticky;
  top: 0px !important;
  align-self: flex-start;
  height: max-content;
  z-index: 10;
}
.warp {
  width: 100%;
}
</style>
